module.exports = __webpack_public_path__ + "img/logo39.3c723ff8.png";